/* ==============================================
   KĀRU Widerrufs-Modal (§ 356a BGB)
   Vanilla JS – no dependencies
   ============================================== */
(function() {
  'use strict';

  var PENDING_KEY = 'kw_pending';

  var modal, dialog, form, overlay;
  var bodyField, orderInput, emailInput, messageInput, counter;
  var summaryEls = {};

  /* ── DOM Ready ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    modal = document.getElementById('karu-widerruf-modal');
    if (!modal) return;

    dialog = modal.querySelector('.kw-dialog');
    overlay = modal.querySelector('[data-kw-overlay]');
    form = modal.querySelector('#karu-widerruf-form');
    bodyField = modal.querySelector('#kw-body-field');
    orderInput = modal.querySelector('#kw-order-number');
    emailInput = modal.querySelector('#kw-email');
    messageInput = modal.querySelector('#kw-message');
    counter = modal.querySelector('#kw-message-counter');

    summaryEls.order = modal.querySelector('[data-kw-summary="order"]');
    summaryEls.email = modal.querySelector('[data-kw-summary="email"]');
    summaryEls.message = modal.querySelector('[data-kw-summary="message"]');

    wireTriggers();
    wireModalControls();
    wireFormControls();
    handleSuccessRedirect();
  }

  /* ============================================
     TRIGGER LINKS
     ============================================ */
  function wireTriggers() {
    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-kw-open]');
      if (!trigger) return;
      e.preventDefault();
      openModal(1);
    });
  }

  /* ============================================
     OPEN / CLOSE
     ============================================ */
  function openModal(step) {
    modal.hidden = false;
    /* force reflow so transition kicks in */
    void modal.offsetWidth;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('kw-no-scroll');
    showStep(step || 1);

    /* Focus management */
    setTimeout(function() {
      focusFirstFocusable();
    }, 50);
  }

  function closeModal(force) {
    if (!force && isDirty()) {
      if (!window.confirm(getLocalisedDirtyWarning())) return;
    }
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('kw-no-scroll');
    setTimeout(function() {
      modal.hidden = true;
      /* Reset to step 1 for next open (only if not in success state) */
      if (modal.getAttribute('data-step') !== '3') {
        showStep(1);
      }
    }, 250);
  }

  function getLocalisedDirtyWarning() {
    /* Single string, baked in DOM via data-attribute would be cleaner but
       keeping JS-light: hardcode DE matching the locale file. */
    return 'Ihre Eingaben gehen verloren. Trotzdem schließen?';
  }

  function isDirty() {
    if (modal.getAttribute('data-step') === '3') return false;
    return (orderInput.value.trim() !== '' ||
            emailInput.value.trim() !== '' ||
            messageInput.value.trim() !== '');
  }

  function wireModalControls() {
    /* Close buttons (with dirty warning) */
    modal.addEventListener('click', function(e) {
      if (e.target.closest('[data-kw-close]')) {
        closeModal(false);
        return;
      }
      if (e.target.closest('[data-kw-close-success]')) {
        closeModal(true);
        return;
      }
      if (e.target.closest('[data-kw-overlay]')) {
        closeModal(false);
        return;
      }
    });

    /* ESC */
    document.addEventListener('keydown', function(e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        if (modal.getAttribute('data-step') === '3') {
          closeModal(true);
          cleanUrl();
        } else {
          closeModal(false);
        }
      } else if (e.key === 'Tab') {
        trapFocus(e);
      }
    });
  }

  /* ============================================
     STEPS
     ============================================ */
  function showStep(step) {
    modal.setAttribute('data-step', String(step));
    /* Toggle visibility of each step block */
    var steps = modal.querySelectorAll('[data-kw-step]');
    steps.forEach(function(el) {
      el.hidden = (el.getAttribute('data-kw-step') !== String(step));
    });
    /* Toggle title spans */
    var titles = modal.querySelectorAll('[data-kw-title-step]');
    titles.forEach(function(el) {
      el.hidden = (el.getAttribute('data-kw-title-step') !== String(step));
    });
  }

  /* ============================================
     FORM CONTROLS
     ============================================ */
  function wireFormControls() {
    /* Char counter */
    if (messageInput && counter) {
      var max = parseInt(messageInput.getAttribute('maxlength')) || 1000;
      messageInput.addEventListener('input', function() {
        counter.textContent = messageInput.value.length + ' / ' + max;
      });
    }

    /* Next button */
    var nextBtn = modal.querySelector('[data-kw-next]');
    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        if (!validateStep1()) return;
        populateSummary();
        showStep(2);
        focusPrimary();
      });
    }

    /* Back button */
    var backBtn = modal.querySelector('[data-kw-back]');
    if (backBtn) {
      backBtn.addEventListener('click', function() {
        showStep(1);
        setTimeout(function() {
          if (orderInput) orderInput.focus();
        }, 50);
      });
    }

    /* Submit button – AJAX, kein Page-Reload */
    var submitBtn = modal.querySelector('[data-kw-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function() {
        composeBody();
        submitWiderruf(submitBtn);
      });
    }

    /* Live clear of error/warning state while typing */
    [orderInput, emailInput].forEach(function(input) {
      if (!input) return;
      input.addEventListener('input', function() {
        var wrap = input.closest('.kw-field');
        if (wrap) { wrap.classList.remove('kw-field--error'); wrap.classList.remove('kw-field--warning'); }
        var parent = input.parentElement.parentElement;
        var existingErr = parent.querySelector('.kw-field-error[data-for="' + input.id + '"]');
        if (existingErr) existingErr.remove();
        var existingWarn = parent.querySelector('.kw-field-warning[data-for="' + input.id + '"]');
        if (existingWarn) existingWarn.remove();
      });
    });
  }

  var ORDER_PATTERN = /^MK-\d+$/i;

  function validateStep1() {
    clearErrors();
    clearWarnings();
    var ok = true;

    var orderVal = orderInput.value.trim();
    if (orderVal === '') {
      showError(orderInput, 'Bitte ausfüllen.');
      ok = false;
    } else {
      /* Soft check: kein Block, nur Hinweis. Wenn Format passt: normalisieren. */
      if (ORDER_PATTERN.test(orderVal)) {
        orderInput.value = orderVal.replace(/^mk-/i, 'MK-');
      } else {
        showWarning(orderInput, 'Das sieht nicht nach einer Bestellnummer aus. Bestellnummern haben das Format MK-12345.');
      }
    }

    if (emailInput.value.trim() === '') {
      showError(emailInput, 'Bitte ausfüllen.');
      ok = false;
    } else if (!isValidEmail(emailInput.value.trim())) {
      showError(emailInput, 'Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      ok = false;
    }

    if (!ok) {
      var firstErr = modal.querySelector('.kw-field--error .input__field');
      if (firstErr) firstErr.focus();
    }
    return ok;
  }

  function clearWarnings() {
    modal.querySelectorAll('.kw-field--warning').forEach(function(el) {
      el.classList.remove('kw-field--warning');
    });
    modal.querySelectorAll('.kw-field-warning').forEach(function(el) {
      el.remove();
    });
  }

  function showWarning(input, msg) {
    var wrap = input.closest('.kw-field');
    if (wrap) wrap.classList.add('kw-field--warning');
    var p = document.createElement('p');
    p.className = 'kw-field-warning';
    p.setAttribute('data-for', input.id);
    p.textContent = msg;
    if (wrap && wrap.parentNode) {
      wrap.parentNode.insertBefore(p, wrap.nextSibling);
    }
  }

  function clearErrors() {
    modal.querySelectorAll('.kw-field--error').forEach(function(el) {
      el.classList.remove('kw-field--error');
    });
    modal.querySelectorAll('.kw-field-error').forEach(function(el) {
      el.remove();
    });
  }

  function showError(input, msg) {
    var wrap = input.closest('.kw-field');
    if (wrap) wrap.classList.add('kw-field--error');
    var p = document.createElement('p');
    p.className = 'kw-field-error';
    p.setAttribute('data-for', input.id);
    p.textContent = msg;
    if (wrap && wrap.parentNode) {
      wrap.parentNode.insertBefore(p, wrap.nextSibling);
    }
  }

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  function populateSummary() {
    summaryEls.order.textContent = orderInput.value.trim();
    summaryEls.email.textContent = emailInput.value.trim();
    var msg = messageInput.value.trim();
    summaryEls.message.textContent = msg !== '' ? msg : '—';
  }

  function composeBody() {
    var orderNumber = orderInput.value.trim();
    var email = emailInput.value.trim();
    var message = messageInput.value.trim();
    var iso = new Date().toISOString();

    /* Subject: dynamisch mit Bestellnummer für leichtes Filtern in Gorgias */
    var subjectField = document.getElementById('kw-subject-field');
    if (subjectField) {
      subjectField.value = 'Widerruf §356a BGB – ' + orderNumber;
    }

    /* Body: Marker in erster Zeile, dann Pipe-getrennte Felder (überlebt
       Whitespace-Collapse in Gorgias-Templates). Strukturierte Felder gehen
       zusätzlich als contact[…] mit. */
    var body = '';
    body += '[WIDERRUF §356a BGB]\n\n';
    body += '--- Pflichtangaben ---\n';
    body += 'Bestellnummer | ' + orderNumber + '\n';
    body += 'E-Mail        | ' + email + '\n';
    body += 'Abgabe (UTC)  | ' + iso + '\n';
    body += '\n';
    body += '--- Mitteilung (optional) ---\n';
    body += (message !== '' ? message : '— keine Angabe —') + '\n';
    body += '\n';
    body += '--- Widerrufserklärung ---\n';
    body += 'Hiermit widerrufe ich den gemäß obenstehender Bestellnummer abgeschlossenen Fernabsatzvertrag.\n';

    bodyField.value = body;
  }

  /* ============================================
     FOCUS TRAP
     ============================================ */
  function getFocusable() {
    if (!dialog) return [];
    var selector = 'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
    var list = Array.prototype.slice.call(dialog.querySelectorAll(selector));
    /* Exclude elements hidden by parents (other steps, hidden title spans) */
    return list.filter(function(el) {
      if (el.hidden) return false;
      var p = el.parentElement;
      while (p && p !== dialog) {
        if (p.hidden) return false;
        p = p.parentElement;
      }
      return true;
    });
  }

  function focusFirstFocusable() {
    var f = getFocusable();
    if (f.length) f[0].focus();
  }

  function focusPrimary() {
    var primary = modal.querySelector('[data-kw-step="' + modal.getAttribute('data-step') + '"] .button--primary');
    if (primary) primary.focus();
  }

  function trapFocus(e) {
    var f = getFocusable();
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0];
    var last = f[f.length - 1];
    var active = document.activeElement;

    if (e.shiftKey) {
      if (active === first || !dialog.contains(active)) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (active === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  /* ============================================
     SUBMIT via Hidden iFrame – kein Page-Reload, Success im Modal
     Native form-target=iframe Submit umgeht CSRF/CORS/Accept-Probleme,
     die einen fetch() POST zu /contact blockieren würden.
     ============================================ */
  var submitInFlight = false;
  var submitTimeout = null;

  function submitWiderruf(btn) {
    if (!form || !btn || submitInFlight) return;
    var originalLabel = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Wird übermittelt …';

    var iframe = document.getElementById('karu-widerruf-iframe');
    if (!iframe) {
      /* Fallback: kein iFrame gefunden – native submit (Page reload) */
      form.submit();
      return;
    }

    submitInFlight = true;

    function onIframeLoad() {
      if (!submitInFlight) return;
      submitInFlight = false;
      clearTimeout(submitTimeout);
      iframe.removeEventListener('load', onIframeLoad);
      btn.disabled = false;
      btn.textContent = originalLabel;
      showStep(3);
      focusPrimary();
    }

    iframe.addEventListener('load', onIframeLoad);

    /* Sicherheits-Timeout: falls iframe-load nicht feuert, nach 8s als Erfolg behandeln
       (Shopify hat die Submission höchstwahrscheinlich verarbeitet). */
    submitTimeout = setTimeout(function() {
      if (!submitInFlight) return;
      submitInFlight = false;
      iframe.removeEventListener('load', onIframeLoad);
      btn.disabled = false;
      btn.textContent = originalLabel;
      showStep(3);
      focusPrimary();
    }, 8000);

    /* Native submit – Form-target ist 'karu-widerruf-iframe', main page bleibt */
    form.submit();
  }

  function showSubmitError() {
    /* Inline error oberhalb der Action-Buttons in Step 2 */
    var step2 = modal.querySelector('[data-kw-step="2"]');
    if (!step2) { window.alert('Übermittlung fehlgeschlagen. Bitte versuchen Sie es erneut.'); return; }
    var existing = step2.querySelector('.kw-submit-error');
    if (existing) existing.remove();
    var err = document.createElement('div');
    err.className = 'kw-submit-error banner banner--error';
    err.setAttribute('role', 'alert');
    err.textContent = 'Übermittlung fehlgeschlagen. Bitte versuchen Sie es erneut oder kontaktieren Sie uns direkt.';
    var actions = step2.querySelector('.kw-actions');
    if (actions) step2.insertBefore(err, actions);
  }

  function handleSuccessRedirect() {
    /* Legacy-Fallback: wenn jemand mit altem sessionStorage-Marker ankommt, bereinigen.
       Kein Auto-Open mehr nötig, weil Submit jetzt via AJAX läuft. */
    try {
      if (sessionStorage.getItem(PENDING_KEY) === '1') {
        sessionStorage.removeItem(PENDING_KEY);
      }
    } catch(e) {}
  }
})();
